import {IssuerStatus, PersonalizationType, WebChargeInterval} from "@/Enums";
import {AddressDto} from "./AddressDto";
import {BankAccountDto} from "./BankAccountDto";
import {EmployeeDto} from "./EmployeeDto";
import {LogoDto} from "./LogoDto";
import {PaymentDetailsDto} from "@/model/PaymentDetailsDto";

export class IssuerDto {
    public id: number | undefined = undefined;
    public companyName: string | undefined = undefined;
    public contactEmployeeId : number | undefined = undefined;
    public contactEmployee : EmployeeDto  = new EmployeeDto();
    public contactAddressId: number | undefined = undefined;
    public contactAddress :  AddressDto = new AddressDto();
    public businessAddressId : number | undefined = undefined;
    public businessAddress : AddressDto = new AddressDto();
    public status: IssuerStatus | undefined = IssuerStatus.Interested;
    public interestedNumber : number | undefined = undefined;
    public businessBankAccountId: number | undefined = undefined;
    public businessBankAccount: BankAccountDto | undefined = undefined;
    public isWebsitePartner: boolean = false;
    public websiteUrl: string | undefined = undefined;
    public isMerchant: boolean = false;
    public paycardCount: number = 0;
    public webChargeInterval: WebChargeInterval | undefined = undefined;
    public personalizePaycard: boolean = false;
    public personalizationType: PersonalizationType | undefined = undefined;
    public websiteLogo : LogoDto | undefined = undefined;
    public websiteLogoId : number | undefined = undefined;
    public paycardLogo : LogoDto | undefined = undefined;
    public paycardLogoId : number | undefined = undefined;
    public paycardText: string | undefined = undefined;
    public debitorId: string | undefined = undefined;
    public contractStart: string | undefined = undefined;
    public contractEnd: string | undefined = undefined;
    public personalizedLogo : LogoDto | undefined = undefined;
    public personalizedLogoId : number | undefined = undefined;
    public paymentDetailsId: number | undefined;
    public paymentDetails: PaymentDetailsDto | undefined;
}
